import { Stack, Typography, TextField, Button } from "@mui/material";
import { ethers } from "ethers";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedNumber } from "modules/shared/components/formatted-number/FormattedNumber";
import { useAccount } from "wagmi";

interface Props {
  name: string;
  balance: string;
  symbol?: string;
}

export const TokenAmountInput = ({ name, balance = "0.00", symbol }: Props) => {
  const { address } = useAccount();
  const { control, setValue } = useFormContext();

  const handleMax = () => {
    setValue(name, balance);
  };

  return (
    <Stack width="100%" alignItems="end">
      {address ? (
        <Typography color="text.secondary" variant="caption">
          Your balance: {balance} {symbol}
        </Typography>
      ) : null}
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <FormattedNumber
            decimalScale={18}
            displayType="input"
            allowNegative={false}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            customInput={TextField}
            placeholder="0.000"
            value={value as any}
            onValueChange={(values) => onChange(values.value)}
            wrapperProps={{ sx: { width: "100%" } }}
            customInputProps={{
              sx: {
                width: "100%",
              },
              InputProps: {
                sx: { backgroundColor: "secondary.main", height: 44 },
                endAdornment: (
                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1" color="text.disabled">
                      {symbol}
                    </Typography>
                    <Button
                      sx={{
                        border: "1px solid",
                        borderColor: "primary.main",
                        paddingBlock: 1,
                      }}
                      onClick={handleMax}
                    >
                      Max
                    </Button>
                  </Stack>
                ),
              },
            }}
          />
        )}
      />
    </Stack>
  );
};
